import React from "react";

const formatNumber = (value) => {
  if (value === null || value === undefined || value === "") return "0";

  return new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 2,
  }).format(Number(value) || 0);
};

const clampPercentage = (value) => {
  const numberValue = Number(value);

  if (!Number.isFinite(numberValue)) {
    return 0;
  }

  return Math.min(Math.max(numberValue, 0), 100);
};

const TopRejectionDepartments = ({ departments = [] }) => {
  return (
    <div className="production-dashboard-card top-rejection-card">
      <div className="card-title-row">
        <div>
          <h3>Top Rejection Departments</h3>
          <p>Departments needing attention</p>
        </div>

        <div className="rejection-alert-indicator">
          <span className="rejection-alert-dot" />
          Live Attention
        </div>
      </div>

      <div className="reject-list">
        {departments.map((item, index) => {
          const percentage = clampPercentage(
            item?.rejectionPercentage,
          );

          const isHighest = index === 0;

          return (
            <div
              className={`reject-row ${
                isHighest ? "highest-rejection" : ""
              }`}
              key={item.deptCode || item.deptName}
              style={{
                "--reject-delay": `${index * 110}ms`,
                "--reject-progress": `${percentage}%`,
              }}
            >
              <div className="reject-rank">
                <span>{index + 1}</span>
              </div>

              <div className="reject-info">
                <div className="reject-department-name-row">
                  <strong>{item.deptName}</strong>

                  {isHighest && (
                    <span className="highest-rejection-badge">
                      Highest
                    </span>
                  )}
                </div>

                <span className="reject-quantity-text">
                  <strong>{formatNumber(item.rejectQty)}</strong>
                  {" reject / "}
                  {formatNumber(item.totalQty)}
                  {" total"}
                </span>

                <div className="reject-progress-track">
                  <div className="reject-progress-value">
                    <span className="reject-progress-glow" />
                  </div>
                </div>
              </div>

              <div className="reject-percent-wrapper">
                <div className="reject-percent">
                  {Number(
                    item?.rejectionPercentage || 0,
                  ).toFixed(2)}
                  <span>%</span>
                </div>

                <small>Rejection</small>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TopRejectionDepartments;